import { User, EntityLabel } from '@esg/esg-global-types';
import { DocumentReference } from 'firebase/firestore';
import { apollo_client } from '../app/db_util';
import { CREATE_PENDING_EXPORT_MUTATOR } from '../graphql/mutations/metric_capture/export';

// Singular and plural label for model entity.
export const export_label: EntityLabel = {
  one: 'Export',
  many: 'Exports'
};

/**
 * Function to create pending export document in firestore for export tracking
 * @param {string} group_id ID of Group which Export is being created for.
 * @param {string} company_id ID of Company which Export is being created for.
 * @param {string} export_type Type of export being generated.
 * @param {User} user_info User requesting export.
 * @returns {DocumentReference}
 */
export const createPendingExport = async (
  group_id: string,
  company_id: string,
  export_type_id: string,
  user_info: User
) => {
  try {
    const pending_document: DocumentReference = await apollo_client
      .mutate({
        mutation: CREATE_PENDING_EXPORT_MUTATOR,
        variables: {
          group_id: group_id,
          company_id: company_id,
          export_type_id: export_type_id,
          user_info: user_info
        }
      })
      .then((response) => {
        return response.data.createPendingExport_archived_1757533192;
      });
    return pending_document;
  } catch (err) {
    const error = `Error while Creating Pending Export in Firebase: ${JSON.stringify({
      message: err instanceof Error ? err.message : '',
      stacktrace: err instanceof Error ? err.stack : ''
    })}`;
    throw new Error(`Error: createPendingExport: ${JSON.stringify(error)}.`);
  }
};
